import { SettingsMenuItem } from '@udacity/udacity-header-v2';

/**
 * Settings-menu item IDs that stay visible for "focused" (Connect / cohort)
 * learners. `community-url` is intentionally included so program-specific
 * community access remains reachable from the profile dropdown for focused
 * enterprise programs (ENT-3978). The header only emits the `community-url`
 * item when the learner actually has a community URL, so listing it here can
 * never surface an empty community link.
 */
export const FOCUSED_SETTINGS_MENU_ITEM_IDS = [
  'personal-info',
  'personalization',
  'notifications',
  'community-url',
  'logout',
];

export function filterSettingsMenuItems({
  items,
  hasFocused,
  isEnterpriseWithoutAllAccess,
  isSsoLearner,
}: {
  items: SettingsMenuItem[];
  hasFocused: boolean;
  isEnterpriseWithoutAllAccess: boolean;
  isSsoLearner?: boolean;
}): SettingsMenuItem[] {
  let filteredItems: SettingsMenuItem[] = items;

  if (isEnterpriseWithoutAllAccess) {
    filteredItems = filteredItems.filter((item) => item.id !== 'subscription');
  }

  // SSO (Okta) learners can't manage linked accounts, so drop that entry.
  if (isSsoLearner) {
    filteredItems = filteredItems.filter((item) => item.id !== 'linked-accounts');
  }

  if (hasFocused) {
    return filteredItems.filter((item) => FOCUSED_SETTINGS_MENU_ITEM_IDS.includes(item.id));
  }

  return filteredItems;
}
